export default "__VITE_ASSET__DBs1pekI__"